export default __webpack_public_path__ + "static/media/the_opportunity_m.93993bc6.jpg";